export default "__VITE_ASSET__SnMw3WDe__"